<template>
    <!-- <page title="confirmTitle">
        <template #pageContainer> -->
            <div v-if="isEmailConfirmed" class="w-100 h-100">
				<v-alert type="success">
					{{ $t(`text.confirmation`) }}
				</v-alert>
				<dashboard-link width="200px" :to="{name: links[0].link}" :title="links[0].text" :icon="links[0].icon"></dashboard-link>
            </div>
        <!-- </template>
    </page> -->
</template>

<script>
import { mapActions } from 'vuex';

import authActions from '../store/actions/auth';
import namespace from '../store/namespace';

// import Page from '../general/Page.vue';
import DashboardLink from '../navigation/DashboardLink.vue';

export default {
	name: 'Confirm',
	components: {
		// Page,
		DashboardLink,
	},
	async mounted() {
		const confirmation = {
			userId: this.userId,
			code: this.code,
		};

		await this.CONFIRM(confirmation);
		this.confirmed = true;
	},
	data() {
		return {
			userId: this.$route.query.userId,
			code: this.$route.query.code,
			confirmed: false,

			links: [{
				text: this.$t('text.loginHeader'),
				link: 'login',
				icon: 'mdi-login',
			}],
		};
	},
	computed: {
		isEmailConfirmed() {
			return this.confirmed === true;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.CONFIRM]),
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

</style>
